import * as Types from '../../../../__generated__/graphql-base-types';

import { gql } from '@apollo/client';
import { CompleteContactInfoFragmentDoc } from '../../../../lib/apollo/__generated__/smartApplyApplicationStateFragments.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetDateOfBirthFormDataQueryVariables = Types.Exact<{
    nodeId: Types.Scalars['ID']['input'];
    indeedApplyableJobId: Types.Scalars['String']['input'];
}>;

export type GetDateOfBirthFormDataQuery = {
    __typename?: 'Query';
    smartApplyApplicationState?:
        | { __typename?: 'AIInterviewInterview' }
        | { __typename?: 'AIJobManSubsetConfiguration' }
        | { __typename?: 'AdhocEmployerInterviewIntent' }
        | { __typename?: 'AdhocJobseekerInterviewIntent' }
        | { __typename?: 'AiDocument' }
        | { __typename?: 'AnalyticsMetricsDataResult' }
        | { __typename?: 'ApplicationDraft' }
        | { __typename?: 'Appointment' }
        | { __typename?: 'AtsSyncCandidateSyncApplication' }
        | { __typename?: 'AtsSyncCandidateSyncInterestedCandidateAsset' }
        | { __typename?: 'AtsSyncCandidateSyncSmartScreeningUpdateAsset' }
        | { __typename?: 'AuditEvent' }
        | { __typename?: 'AutomatableActionResult' }
        | { __typename?: 'AutomatableCalendlyResult' }
        | { __typename?: 'AutomatableEngagementResult' }
        | { __typename?: 'AutomatableKeyValueResult' }
        | { __typename?: 'AutomatableScreenerResult' }
        | { __typename?: 'AutomatableUpdateCandidateResult' }
        | { __typename?: 'AutosourcerBulkEnableTask' }
        | { __typename?: 'Availability' }
        | { __typename?: 'BillingAccount' }
        | { __typename?: 'BillingIdentifier' }
        | { __typename?: 'BulkJobContentOptimization' }
        | { __typename?: 'CalendarConfiguration' }
        | { __typename?: 'Campaign' }
        | { __typename?: 'Candidate' }
        | { __typename?: 'CandidateBio' }
        | { __typename?: 'CandidateFeedbackNote' }
        | { __typename?: 'CandidateFeedbackRating' }
        | { __typename?: 'CandidateFeedbackSentiment' }
        | { __typename?: 'CandidateJourney' }
        | { __typename?: 'CandidateJourneyGroup' }
        | { __typename?: 'CandidateJourneyStage' }
        | { __typename?: 'CandidateSubmission' }
        | { __typename?: 'CandidateSubmissionGroup' }
        | { __typename?: 'CandidateSyncSmartSourcingExportResourceHistory' }
        | { __typename?: 'CategoricalOQVTTaxonomy' }
        | { __typename?: 'ChannelNotification' }
        | { __typename?: 'ChatConversation' }
        | { __typename?: 'ChatConversationAttachment' }
        | { __typename?: 'ChatConversationMessage' }
        | { __typename?: 'CollaborationRequest' }
        | { __typename?: 'CommunicationsHubRequest' }
        | { __typename?: 'CompanyAlert' }
        | { __typename?: 'Conversation' }
        | { __typename?: 'ConversationEvent' }
        | { __typename?: 'CraveComplianceDocument' }
        | { __typename?: 'CraveEmployerDocument' }
        | { __typename?: 'CreditAllocation' }
        | { __typename?: 'CurrentCandidateSubmissionStatus' }
        | { __typename?: 'DedicatedSchedulingFormat' }
        | { __typename?: 'DeepSourcingSession' }
        | { __typename?: 'DeepSourcingSessionHighlightMatch' }
        | { __typename?: 'EjpAutomationTransaction' }
        | { __typename?: 'EjpGroup' }
        | { __typename?: 'EjpJobMatchAutomation' }
        | { __typename?: 'EmployerAdminAction' }
        | { __typename?: 'EmployerAiAutomationsGuardrail' }
        | { __typename?: 'EmployerAnalyticsSavedView' }
        | { __typename?: 'EmployerAutomation' }
        | { __typename?: 'EmployerBillingContractDeal' }
        | { __typename?: 'EmployerBillingContractLead' }
        | { __typename?: 'EmployerDealBonusCredit' }
        | { __typename?: 'EmployerEntity' }
        | { __typename?: 'EmployerHierarchy' }
        | { __typename?: 'EmployerHiringEvent' }
        | { __typename?: 'EmployerHiringEventRsvp' }
        | { __typename?: 'EmployerIntegration' }
        | { __typename?: 'EmployerJob' }
        | { __typename?: 'EmployerJobBatchEdit' }
        | { __typename?: 'EmployerJobGroup' }
        | { __typename?: 'EmployerJobHiringAdvice' }
        | { __typename?: 'EmployerJobTag' }
        | { __typename?: 'EmployerOrganization' }
        | { __typename?: 'EmployerOrganizationType' }
        | { __typename?: 'EmployerOrganizationUser' }
        | { __typename?: 'EmployerOrganizationalUnit' }
        | { __typename?: 'EmployerOrganizationalUnitUser' }
        | { __typename?: 'EmployerRegistration' }
        | { __typename?: 'EmployerUser' }
        | { __typename?: 'EmployerUserCandidateSourcingSettings' }
        | { __typename?: 'EmployerUserCandidateSourcingUxFeatures' }
        | { __typename?: 'EmployerUserGroup' }
        | { __typename?: 'EmployerUserHiringProfile' }
        | { __typename?: 'EmployerUserSettings' }
        | { __typename?: 'EvaluateWorkflow' }
        | { __typename?: 'EvaluateWorkflowStep' }
        | { __typename?: 'ExternalAtsLink' }
        | { __typename?: 'ExternalJobPost' }
        | { __typename?: 'FlexAgencyChargeRateOverride' }
        | { __typename?: 'FlexBurdenProfile' }
        | { __typename?: 'FlexPlacementMargin' }
        | { __typename?: 'FlexPlatformMargin' }
        | { __typename?: 'FlexRateCard' }
        | { __typename?: 'FlexShiftRateType' }
        | { __typename?: 'FlexTimeDependentRate' }
        | { __typename?: 'GhostwriterApplication' }
        | { __typename?: 'GhostwriterFieldResponse' }
        | { __typename?: 'GhostwriterFormField' }
        | { __typename?: 'GhostwriterFormFieldGroup' }
        | { __typename?: 'GhostwriterJob' }
        | { __typename?: 'GhostwriterResponseGroup' }
        | { __typename?: 'GhostwriterResponseSet' }
        | { __typename?: 'HiringLabNationalAI' }
        | { __typename?: 'HiringLabNationalPayTransparency' }
        | { __typename?: 'HiringLabNationalPosting' }
        | { __typename?: 'HiringLabNationalRemote' }
        | { __typename?: 'HiringLabNationalWage' }
        | { __typename?: 'HiringLabRegionalPayTransparency' }
        | { __typename?: 'HiringLabRegionalPosting' }
        | { __typename?: 'HiringLabSectoralPayTransparency' }
        | { __typename?: 'HiringLabSectoralPosting' }
        | { __typename?: 'HiringLabSectoralRemote' }
        | { __typename?: 'HiringLabSectoralWage' }
        | { __typename?: 'HiringProfile' }
        | { __typename?: 'IAMConfiguration' }
        | { __typename?: 'InboundCandidateSyncConfiguration' }
        | { __typename?: 'InboundCandidateSyncResult' }
        | { __typename?: 'IndeedAssistantContextIndex' }
        | { __typename?: 'IndeedAssistantContextItemIngestionJob' }
        | { __typename?: 'IndeedAssistantEmbeddingProvider' }
        | { __typename?: 'InsertionOrder' }
        | { __typename?: 'InterviewLobby' }
        | { __typename?: 'InterviewLobbyAppointment' }
        | { __typename?: 'InterviewNowSession' }
        | { __typename?: 'InterviewRoom' }
        | { __typename?: 'InterviewTemplate' }
        | { __typename?: 'JPCorporateNumberCompanyData' }
        | { __typename?: 'JapanJobPostingForm' }
        | { __typename?: 'JobAlert' }
        | { __typename?: 'JobApplication' }
        | { __typename?: 'JobContentForm' }
        | { __typename?: 'JobMonetizationPolicy' }
        | { __typename?: 'JobPost' }
        | { __typename?: 'JobPostingForm' }
        | { __typename?: 'JobSeekerInvite' }
        | { __typename?: 'JobseekerInterviewNowSession' }
        | { __typename?: 'LibraryAuthor' }
        | { __typename?: 'LibraryBook' }
        | { __typename?: 'ManagedEmployerInterviewIntent' }
        | { __typename?: 'ManagedJobseekerInterviewIntent' }
        | { __typename?: 'MessageTemplate' }
        | { __typename?: 'MetadataCatalogDataAsset' }
        | { __typename?: 'MetadataCatalogDataAssetField' }
        | { __typename?: 'MultiLocationJobPostingForm' }
        | { __typename?: 'Notice' }
        | { __typename?: 'OneLogActivity' }
        | { __typename?: 'PartnerWebhook' }
        | { __typename?: 'PathfinderM2Suggestion' }
        | { __typename?: 'PathfinderSkill' }
        | { __typename?: 'PphContract' }
        | { __typename?: 'PreApplyCandidate' }
        | { __typename?: 'Project' }
        | { __typename?: 'ProjectJobseeker' }
        | { __typename?: 'Proposal' }
        | { __typename?: 'RematchInvitation' }
        | { __typename?: 'ResourceGroup' }
        | { __typename?: 'RestrictedInterviewLobby' }
        | { __typename?: 'SchedulingParticipantGroup' }
        | { __typename?: 'ScoutAIDocument' }
        | { __typename?: 'ScoutApplication' }
        | { __typename?: 'ScoutChatMessage' }
        | { __typename?: 'ScoutConversation' }
        | { __typename?: 'ScoutDeepSourcingResult' }
        | { __typename?: 'ScoutMatchMeter' }
        | { __typename?: 'ScoutMatchProfile' }
        | { __typename?: 'ScoutMatchProfileDocument' }
        | {
              __typename: 'SmartApplyApplicationState';
              id: string;
              draftId: string;
              contactInfo?:
                  | {
                        __typename: 'ContactInfoSmartApplyApplicationState';
                        firstName?: string | null | undefined;
                        lastName?: string | null | undefined;
                        firstNamePronunciation?: string | null | undefined;
                        lastNamePronunciation?: string | null | undefined;
                        email?: any | null | undefined;
                        phoneNumber?: string | null | undefined;
                        dateOfBirth?: string | null | undefined;
                        gender?: string | null | undefined;
                        area?: string | null | undefined;
                        city?: string | null | undefined;
                        country?: string | null | undefined;
                        resumeContactInfo?:
                            | {
                                  __typename: 'ResumeContactInfo';
                                  phone?: string | null | undefined;
                                  name?:
                                      | {
                                            __typename: 'ResumeContactInfoName';
                                            firstName?: string | null | undefined;
                                            lastName?: string | null | undefined;
                                        }
                                      | null
                                      | undefined;
                                  location?:
                                      | {
                                            __typename: 'ResumeContactInfoLocation';
                                            city?: string | null | undefined;
                                            country?: string | null | undefined;
                                        }
                                      | null
                                      | undefined;
                              }
                            | null
                            | undefined;
                    }
                  | null
                  | undefined;
          }
        | { __typename?: 'SocialImpactJobseeker' }
        | { __typename?: 'SocialImpactPartner' }
        | { __typename?: 'SocialImpactPartnerAdmin' }
        | { __typename?: 'SourcingHitlPendingQuestion' }
        | { __typename?: 'SsiEmployerLink' }
        | { __typename?: 'SsiNotificationRule' }
        | { __typename?: 'SsiPlatformInstallation' }
        | { __typename?: 'StoredDataReport' }
        | { __typename?: 'SystemNotice' }
        | { __typename?: 'TalentProjectCandidateNote' }
        | { __typename?: 'TalentSubscription' }
        | { __typename?: 'TalentSubscriptionTemplate' }
        | { __typename?: 'TestEntity' }
        | { __typename?: 'TrustedMediaNetworkJob' }
        | { __typename?: 'WorkedShift' }
        | { __typename?: 'WorkedShiftMeal' }
        | { __typename?: 'WorkflowConfigRule' }
        | null
        | undefined;
    applyParameters?:
        | {
              __typename?: 'ApplyParametersPayload';
              jobDetails: {
                  __typename?: 'ApplyParametersJobDetailsPayload';
                  standardFields: {
                      __typename?: 'ApplyParametersStandardFieldsPayload';
                      name: {
                          __typename?: 'ApplyParametersNameFieldPayload';
                          format: Types.ApplyParametersNameFormat;
                      };
                  };
              };
          }
        | null
        | undefined;
};

export type UpdateLightApplyDateOfBirthMutationVariables = Types.Exact<{
    input: Types.SmartApplyApplicationStateInput;
    updateContactInfoInput: Types.UpdateContactInfoSmartApplyApplicationStateInput;
}>;

export type UpdateLightApplyDateOfBirthMutation = {
    __typename?: 'Mutation';
    smartApplyApplicationState: {
        __typename?: 'SmartApplyApplicationStateMutations';
        updateContactInfo?:
            | {
                  __typename?: 'UpdateContactInfoSmartApplyApplicationStatePayload';
                  state: {
                      __typename?: 'ContactInfoSmartApplyApplicationState';
                      firstName?: string | null | undefined;
                      lastName?: string | null | undefined;
                      firstNamePronunciation?: string | null | undefined;
                      lastNamePronunciation?: string | null | undefined;
                      email?: any | null | undefined;
                      phoneNumber?: string | null | undefined;
                      dateOfBirth?: string | null | undefined;
                      gender?: string | null | undefined;
                      area?: string | null | undefined;
                      city?: string | null | undefined;
                      country?: string | null | undefined;
                      resumeContactInfo?:
                          | {
                                __typename?: 'ResumeContactInfo';
                                phone?: string | null | undefined;
                                name?:
                                    | {
                                          __typename?: 'ResumeContactInfoName';
                                          firstName?: string | null | undefined;
                                          lastName?: string | null | undefined;
                                      }
                                    | null
                                    | undefined;
                                location?:
                                    | {
                                          __typename?: 'ResumeContactInfoLocation';
                                          city?: string | null | undefined;
                                          country?: string | null | undefined;
                                      }
                                    | null
                                    | undefined;
                            }
                          | null
                          | undefined;
                  };
                  status?:
                      | {
                            __typename?: 'UpdateContactInfoSmartApplyApplicationStatus';
                            updateProfile?: boolean | null | undefined;
                        }
                      | null
                      | undefined;
              }
            | null
            | undefined;
    };
};

export const GetDateOfBirthFormDataDocument = gql`
    query GetDateOfBirthFormData($nodeId: ID!, $indeedApplyableJobId: String!) {
        smartApplyApplicationState: node(id: $nodeId) {
            ... on SmartApplyApplicationState {
                ...CompleteContactInfo
            }
        }
        applyParameters(indeedApplyableJobId: $indeedApplyableJobId) {
            jobDetails {
                standardFields {
                    name {
                        format
                    }
                }
            }
        }
    }
    ${CompleteContactInfoFragmentDoc}
`;

/**
 * __useGetDateOfBirthFormDataQuery__
 *
 * To run a query within a React component, call `useGetDateOfBirthFormDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDateOfBirthFormDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDateOfBirthFormDataQuery({
 *   variables: {
 *      nodeId: // value for 'nodeId'
 *      indeedApplyableJobId: // value for 'indeedApplyableJobId'
 *   },
 * });
 */
export function useGetDateOfBirthFormDataQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetDateOfBirthFormDataQuery,
        GetDateOfBirthFormDataQueryVariables
    > &
        ({ variables: GetDateOfBirthFormDataQueryVariables; skip?: boolean } | { skip: boolean }),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<GetDateOfBirthFormDataQuery, GetDateOfBirthFormDataQueryVariables>(
        GetDateOfBirthFormDataDocument,
        options,
    );
}
export function useGetDateOfBirthFormDataLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetDateOfBirthFormDataQuery,
        GetDateOfBirthFormDataQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<GetDateOfBirthFormDataQuery, GetDateOfBirthFormDataQueryVariables>(
        GetDateOfBirthFormDataDocument,
        options,
    );
}
export function useGetDateOfBirthFormDataSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetDateOfBirthFormDataQuery,
              GetDateOfBirthFormDataQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetDateOfBirthFormDataQuery,
        GetDateOfBirthFormDataQueryVariables
    >(GetDateOfBirthFormDataDocument, options);
}
export type GetDateOfBirthFormDataQueryHookResult = ReturnType<
    typeof useGetDateOfBirthFormDataQuery
>;
export type GetDateOfBirthFormDataLazyQueryHookResult = ReturnType<
    typeof useGetDateOfBirthFormDataLazyQuery
>;
export type GetDateOfBirthFormDataSuspenseQueryHookResult = ReturnType<
    typeof useGetDateOfBirthFormDataSuspenseQuery
>;
export type GetDateOfBirthFormDataQueryResult = Apollo.QueryResult<
    GetDateOfBirthFormDataQuery,
    GetDateOfBirthFormDataQueryVariables
>;
export const UpdateLightApplyDateOfBirthDocument = gql`
    mutation UpdateLightApplyDateOfBirth(
        $input: SmartApplyApplicationStateInput!
        $updateContactInfoInput: UpdateContactInfoSmartApplyApplicationStateInput!
    ) {
        smartApplyApplicationState(input: $input) {
            updateContactInfo(input: $updateContactInfoInput) {
                state {
                    firstName
                    lastName
                    firstNamePronunciation
                    lastNamePronunciation
                    email
                    phoneNumber
                    dateOfBirth
                    gender
                    area
                    city
                    country
                    resumeContactInfo {
                        name {
                            firstName
                            lastName
                        }
                        phone
                        location {
                            city
                            country
                        }
                    }
                }
                status {
                    updateProfile
                }
            }
        }
    }
`;
export type UpdateLightApplyDateOfBirthMutationFn = Apollo.MutationFunction<
    UpdateLightApplyDateOfBirthMutation,
    UpdateLightApplyDateOfBirthMutationVariables
>;

/**
 * __useUpdateLightApplyDateOfBirthMutation__
 *
 * To run a mutation, you first call `useUpdateLightApplyDateOfBirthMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLightApplyDateOfBirthMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLightApplyDateOfBirthMutation, { data, loading, error }] = useUpdateLightApplyDateOfBirthMutation({
 *   variables: {
 *      input: // value for 'input'
 *      updateContactInfoInput: // value for 'updateContactInfoInput'
 *   },
 * });
 */
export function useUpdateLightApplyDateOfBirthMutation(
    baseOptions?: Apollo.MutationHookOptions<
        UpdateLightApplyDateOfBirthMutation,
        UpdateLightApplyDateOfBirthMutationVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation<
        UpdateLightApplyDateOfBirthMutation,
        UpdateLightApplyDateOfBirthMutationVariables
    >(UpdateLightApplyDateOfBirthDocument, options);
}
export type UpdateLightApplyDateOfBirthMutationHookResult = ReturnType<
    typeof useUpdateLightApplyDateOfBirthMutation
>;
export type UpdateLightApplyDateOfBirthMutationResult =
    Apollo.MutationResult<UpdateLightApplyDateOfBirthMutation>;
export type UpdateLightApplyDateOfBirthMutationOptions = Apollo.BaseMutationOptions<
    UpdateLightApplyDateOfBirthMutation,
    UpdateLightApplyDateOfBirthMutationVariables
>;
